export class LuggageSizeData
{
    value:number;
    luggageSizeColId:number;
    luggageSizeRowId:number;
    luggageSizeId:number;
}